// Campaign signup code (?ref=<code>) and landing plan (?plan=1|2|3). The backend
// decides whether the code is valid; here we only keep both across the redirects
// that drop the query string.

const STORAGE_KEY = 'reveca_entry_code';
const QUERY_PARAM = 'ref';
const PLAN_QUERY_PARAM = 'plan';
const TTL_MS = 24 * 60 * 60 * 1000;

interface StoredEntryCode {
  code: string;
  plan?: string;
  capturedAt: number;
}

export function captureEntryCode(search: string = window.location.search): void {
  const params = new URLSearchParams(search);
  const code = params.get(QUERY_PARAM)?.trim();
  if (!code) return;
  const plan = params.get(PLAN_QUERY_PARAM)?.trim() || undefined;
  try {
    const value: StoredEntryCode = { code, plan, capturedAt: Date.now() };
    localStorage.setItem(STORAGE_KEY, JSON.stringify(value));
  } catch {
    // Storage unavailable (private mode): signup falls back to the standard flow.
  }
}

function readStored(): StoredEntryCode | undefined {
  try {
    const raw = localStorage.getItem(STORAGE_KEY);
    if (!raw) return undefined;
    const stored = JSON.parse(raw) as StoredEntryCode;
    if (!stored?.code || Date.now() - stored.capturedAt > TTL_MS) {
      localStorage.removeItem(STORAGE_KEY);
      return undefined;
    }
    return stored;
  } catch {
    return undefined;
  }
}

export function getEntryCode(): string | undefined {
  return readStored()?.code;
}

export function getEntryPlan(): string | undefined {
  return readStored()?.plan;
}

export function clearEntryCode(): void {
  try {
    localStorage.removeItem(STORAGE_KEY);
  } catch {
    // ignore
  }
}
